import Skeleton from './src/skeleton'
import SkeletonItem from './src/skeletonItem'

Skeleton.Item = SkeletonItem;
export default Skeleton
